import React from "react";

const CheckIcon = () => (
  <svg
    className="toast-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="8" cy="8" r="7.5" stroke="currentColor" strokeOpacity="0.4" />
    <path
      d="M4.5 8.5l2.5 2.5 4.5-5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function Toast({ message, visible, onDismiss }) {
  return (
    <div
      className={`toast${visible ? " toast--visible" : ""}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <CheckIcon />
      <span className="toast-message">{message}</span>
      <button
        type="button"
        className="toast-close"
        onClick={onDismiss}
        aria-label="Dismiss notification"
        tabIndex={visible ? 0 : -1}
      >
        ×
      </button>
    </div>
  );
}
